<ul class="layout-menu">
    @for (item of model; track item.label || $index) {
        @if (!item.separator) {
            <li app-menuitem [item]="item" [root]="true" [index]="$index"></li>
        } @else {
            <li class="menu-separator"></li>
        }
    }
</ul>
